var map = {
	"./announcement": [
		"nYdL",
		63
	],
	"./announcement/": [
		"nYdL",
		63
	],
	"./announcement/faq": [
		"6Tcg",
		0,
		5
	],
	"./announcement/faq-class": [
		"HWQX",
		0,
		33
	],
	"./announcement/faq-class/": [
		"HWQX",
		0,
		33
	],
	"./announcement/faq-class/index": [
		"HWQX",
		0,
		33
	],
	"./announcement/faq-class/index.less": [
		"hyXB",
		116
	],
	"./announcement/faq-class/index.vue": [
		"HWQX",
		0,
		33
	],
	"./announcement/faq/": [
		"6Tcg",
		0,
		5
	],
	"./announcement/faq/index": [
		"6Tcg",
		0,
		5
	],
	"./announcement/faq/index.less": [
		"eQPv",
		115
	],
	"./announcement/faq/index.vue": [
		"6Tcg",
		0,
		5
	],
	"./announcement/index": [
		"nYdL",
		63
	],
	"./announcement/index.vue": [
		"nYdL",
		63
	],
	"./announcement/official-website": [
		"8Gso",
		0,
		19
	],
	"./announcement/official-website/": [
		"8Gso",
		0,
		19
	],
	"./announcement/official-website/index": [
		"8Gso",
		0,
		19
	],
	"./announcement/official-website/index.less": [
		"ij6n",
		114
	],
	"./announcement/official-website/index.vue": [
		"8Gso",
		0,
		19
	],
	"./app": [
		"gF6L",
		62
	],
	"./app/": [
		"gF6L",
		62
	],
	"./app/daily-record": [
		"XBg7",
		0,
		41
	],
	"./app/daily-record/": [
		"XBg7",
		0,
		41
	],
	"./app/daily-record/index": [
		"XBg7",
		0,
		41
	],
	"./app/daily-record/index.less": [
		"fbe6",
		113
	],
	"./app/daily-record/index.vue": [
		"XBg7",
		0,
		41
	],
	"./app/error-daily-record": [
		"NRni",
		0,
		51
	],
	"./app/error-daily-record/": [
		"NRni",
		0,
		51
	],
	"./app/error-daily-record/index": [
		"NRni",
		0,
		51
	],
	"./app/error-daily-record/index.less": [
		"PcQw",
		112
	],
	"./app/error-daily-record/index.vue": [
		"NRni",
		0,
		51
	],
	"./app/index": [
		"gF6L",
		62
	],
	"./app/index.vue": [
		"gF6L",
		62
	],
	"./app/list": [
		"/bIP",
		0,
		4
	],
	"./app/list/": [
		"/bIP",
		0,
		4
	],
	"./app/list/index": [
		"/bIP",
		0,
		4
	],
	"./app/list/index.less": [
		"rsHK",
		111
	],
	"./app/list/index.vue": [
		"/bIP",
		0,
		4
	],
	"./backstage": [
		"nc0V",
		60
	],
	"./backstage/": [
		"nc0V",
		60
	],
	"./backstage/account": [
		"kY49",
		61
	],
	"./backstage/account/": [
		"kY49",
		61
	],
	"./backstage/account/action": [
		"xAsC",
		21
	],
	"./backstage/account/action/": [
		"xAsC",
		21
	],
	"./backstage/account/action/index": [
		"xAsC",
		21
	],
	"./backstage/account/action/index.less": [
		"xIVK",
		110
	],
	"./backstage/account/action/index.vue": [
		"xAsC",
		21
	],
	"./backstage/account/index": [
		"kY49",
		61
	],
	"./backstage/account/index.vue": [
		"kY49",
		61
	],
	"./backstage/account/list": [
		"UvaK",
		0,
		6
	],
	"./backstage/account/list/": [
		"UvaK",
		0,
		6
	],
	"./backstage/account/list/index": [
		"UvaK",
		0,
		6
	],
	"./backstage/account/list/index.less": [
		"ff9V",
		109
	],
	"./backstage/account/list/index.vue": [
		"UvaK",
		0,
		6
	],
	"./backstage/account/menu": [
		"2fHP",
		50
	],
	"./backstage/account/menu/": [
		"2fHP",
		50
	],
	"./backstage/account/menu/index": [
		"2fHP",
		50
	],
	"./backstage/account/menu/index.less": [
		"y69i",
		108
	],
	"./backstage/account/menu/index.vue": [
		"2fHP",
		50
	],
	"./backstage/account/role": [
		"BqUh",
		23
	],
	"./backstage/account/role/": [
		"BqUh",
		23
	],
	"./backstage/account/role/index": [
		"BqUh",
		23
	],
	"./backstage/account/role/index.less": [
		"VnYy",
		107
	],
	"./backstage/account/role/index.vue": [
		"BqUh",
		23
	],
	"./backstage/index": [
		"nc0V",
		60
	],
	"./backstage/index.vue": [
		"nc0V",
		60
	],
	"./backstage/myAccount": [
		"kzJ8",
		59
	],
	"./backstage/myAccount/": [
		"kzJ8",
		59
	],
	"./backstage/myAccount/change-info": [
		"HY7A",
		11
	],
	"./backstage/myAccount/change-info/": [
		"HY7A",
		11
	],
	"./backstage/myAccount/change-info/index": [
		"HY7A",
		11
	],
	"./backstage/myAccount/change-info/index.less": [
		"TOzc",
		106
	],
	"./backstage/myAccount/change-info/index.vue": [
		"HY7A",
		11
	],
	"./backstage/myAccount/change-password": [
		"PhuP",
		25
	],
	"./backstage/myAccount/change-password/": [
		"PhuP",
		25
	],
	"./backstage/myAccount/change-password/index": [
		"PhuP",
		25
	],
	"./backstage/myAccount/change-password/index.less": [
		"sq04",
		105
	],
	"./backstage/myAccount/change-password/index.vue": [
		"PhuP",
		25
	],
	"./backstage/myAccount/index": [
		"kzJ8",
		59
	],
	"./backstage/myAccount/index.vue": [
		"kzJ8",
		59
	],
	"./course": [
		"b8x+",
		58
	],
	"./course/": [
		"b8x+",
		58
	],
	"./course/add-practice": [
		"IOvv",
		0,
		16
	],
	"./course/add-practice/": [
		"IOvv",
		0,
		16
	],
	"./course/add-practice/index": [
		"IOvv",
		0,
		16
	],
	"./course/add-practice/index.less": [
		"VE1/",
		104
	],
	"./course/add-practice/index.vue": [
		"IOvv",
		0,
		16
	],
	"./course/add-video": [
		"dSNZ",
		0,
		40
	],
	"./course/add-video/": [
		"dSNZ",
		0,
		40
	],
	"./course/add-video/index": [
		"dSNZ",
		0,
		40
	],
	"./course/add-video/index.less": [
		"9sju",
		103
	],
	"./course/add-video/index.vue": [
		"dSNZ",
		0,
		40
	],
	"./course/index": [
		"b8x+",
		58
	],
	"./course/index.vue": [
		"b8x+",
		58
	],
	"./course/practice-tasks": [
		"U4nG",
		0,
		32
	],
	"./course/practice-tasks/": [
		"U4nG",
		0,
		32
	],
	"./course/practice-tasks/index": [
		"U4nG",
		0,
		32
	],
	"./course/practice-tasks/index.less": [
		"Sn89",
		102
	],
	"./course/practice-tasks/index.vue": [
		"U4nG",
		0,
		32
	],
	"./course/video": [
		"kHZR",
		0,
		10
	],
	"./course/video/": [
		"kHZR",
		0,
		10
	],
	"./course/video/index": [
		"kHZR",
		0,
		10
	],
	"./course/video/index.less": [
		"FqS1",
		101
	],
	"./course/video/index.vue": [
		"kHZR",
		0,
		10
	],
	"./design": [
		"Nolj",
		0,
		1
	],
	"./design/": [
		"Nolj",
		0,
		1
	],
	"./design/components/color": [
		"HfOv",
		14
	],
	"./design/components/color/": [
		"HfOv",
		14
	],
	"./design/components/color/index": [
		"HfOv",
		14
	],
	"./design/components/color/index.less": [
		"f+zL",
		100
	],
	"./design/components/color/index.vue": [
		"HfOv",
		14
	],
	"./design/components/comment-tree": [
		"MUza",
		0,
		64
	],
	"./design/components/comment-tree.vue": [
		"MUza",
		0,
		64
	],
	"./design/index": [
		"Nolj",
		0,
		1
	],
	"./design/index.less": [
		"Dtf+",
		99
	],
	"./design/index.vue": [
		"Nolj",
		0,
		1
	],
	"./home": [
		"KR8f",
		0,
		34
	],
	"./home/": [
		"KR8f",
		0,
		34
	],
	"./home/index": [
		"KR8f",
		0,
		34
	],
	"./home/index.less": [
		"m/rq",
		98
	],
	"./home/index.vue": [
		"KR8f",
		0,
		34
	],
	"./kanban": [
		"1+MQ",
		39
	],
	"./kanban/": [
		"1+MQ",
		39
	],
	"./kanban/index": [
		"1+MQ",
		39
	],
	"./kanban/index.less": [
		"EC20",
		97
	],
	"./kanban/index.vue": [
		"1+MQ",
		39
	],
	"./login": [
		"T+/8",
		2
	],
	"./login/": [
		"T+/8",
		2
	],
	"./login/index": [
		"T+/8",
		2
	],
	"./login/index.less": [
		"nkRK",
		96
	],
	"./login/index.vue": [
		"T+/8",
		2
	],
	"./main": [
		"sRz/"
	],
	"./main.vue": [
		"sRz/"
	],
	"./order": [
		"e+iX",
		57
	],
	"./order/": [
		"e+iX",
		57
	],
	"./order/baidu-ai": [
		"RxtY",
		0,
		31
	],
	"./order/baidu-ai/": [
		"RxtY",
		0,
		31
	],
	"./order/baidu-ai/index": [
		"RxtY",
		0,
		31
	],
	"./order/baidu-ai/index.less": [
		"yxCo",
		95
	],
	"./order/baidu-ai/index.vue": [
		"RxtY",
		0,
		31
	],
	"./order/baidu-man-made": [
		"W86G",
		0,
		47
	],
	"./order/baidu-man-made/": [
		"W86G",
		0,
		47
	],
	"./order/baidu-man-made/index": [
		"W86G",
		0,
		47
	],
	"./order/baidu-man-made/index.less": [
		"Obat",
		94
	],
	"./order/baidu-man-made/index.vue": [
		"W86G",
		0,
		47
	],
	"./order/customer-order-manage": [
		"9seh",
		37
	],
	"./order/customer-order-manage/": [
		"9seh",
		37
	],
	"./order/customer-order-manage/components/intelligent-dubbing": [
		"1te+",
		0,
		24
	],
	"./order/customer-order-manage/components/intelligent-dubbing/": [
		"1te+",
		0,
		24
	],
	"./order/customer-order-manage/components/intelligent-dubbing/index": [
		"1te+",
		0,
		24
	],
	"./order/customer-order-manage/components/intelligent-dubbing/index.less": [
		"oJRp",
		93
	],
	"./order/customer-order-manage/components/intelligent-dubbing/index.vue": [
		"1te+",
		0,
		24
	],
	"./order/customer-order-manage/components/listening-and-translation": [
		"YhLD",
		0,
		26
	],
	"./order/customer-order-manage/components/listening-and-translation/": [
		"YhLD",
		0,
		26
	],
	"./order/customer-order-manage/components/listening-and-translation/index": [
		"YhLD",
		0,
		26
	],
	"./order/customer-order-manage/components/listening-and-translation/index.less": [
		"SCmM",
		92
	],
	"./order/customer-order-manage/components/listening-and-translation/index.vue": [
		"YhLD",
		0,
		26
	],
	"./order/customer-order-manage/components/machine-translation": [
		"Af3L",
		0,
		15
	],
	"./order/customer-order-manage/components/machine-translation/": [
		"Af3L",
		0,
		15
	],
	"./order/customer-order-manage/components/machine-translation/index": [
		"Af3L",
		0,
		15
	],
	"./order/customer-order-manage/components/machine-translation/index.less": [
		"vIdx",
		91
	],
	"./order/customer-order-manage/components/machine-translation/index.vue": [
		"Af3L",
		0,
		15
	],
	"./order/customer-order-manage/components/screen-recognition": [
		"iA3P",
		0,
		38
	],
	"./order/customer-order-manage/components/screen-recognition/": [
		"iA3P",
		0,
		38
	],
	"./order/customer-order-manage/components/screen-recognition/index": [
		"iA3P",
		0,
		38
	],
	"./order/customer-order-manage/components/screen-recognition/index.less": [
		"wryF",
		90
	],
	"./order/customer-order-manage/components/screen-recognition/index.vue": [
		"iA3P",
		0,
		38
	],
	"./order/customer-order-manage/index": [
		"9seh",
		37
	],
	"./order/customer-order-manage/index.less": [
		"frd1",
		89
	],
	"./order/customer-order-manage/index.vue": [
		"9seh",
		37
	],
	"./order/index": [
		"e+iX",
		57
	],
	"./order/index.vue": [
		"e+iX",
		57
	],
	"./order/recharge-order-manage": [
		"h2Qi",
		20
	],
	"./order/recharge-order-manage/": [
		"h2Qi",
		20
	],
	"./order/recharge-order-manage/components/intelligent-dubbing": [
		"uZrp",
		0,
		13
	],
	"./order/recharge-order-manage/components/intelligent-dubbing/": [
		"uZrp",
		0,
		13
	],
	"./order/recharge-order-manage/components/intelligent-dubbing/index": [
		"uZrp",
		0,
		13
	],
	"./order/recharge-order-manage/components/intelligent-dubbing/index.less": [
		"tyUt",
		88
	],
	"./order/recharge-order-manage/components/intelligent-dubbing/index.vue": [
		"uZrp",
		0,
		13
	],
	"./order/recharge-order-manage/components/listening-and-translation": [
		"a9cp",
		0,
		45
	],
	"./order/recharge-order-manage/components/listening-and-translation/": [
		"a9cp",
		0,
		45
	],
	"./order/recharge-order-manage/components/listening-and-translation/index": [
		"a9cp",
		0,
		45
	],
	"./order/recharge-order-manage/components/listening-and-translation/index.less": [
		"3MQB",
		87
	],
	"./order/recharge-order-manage/components/listening-and-translation/index.vue": [
		"a9cp",
		0,
		45
	],
	"./order/recharge-order-manage/components/machine-translation": [
		"F4Ma",
		0,
		22
	],
	"./order/recharge-order-manage/components/machine-translation/": [
		"F4Ma",
		0,
		22
	],
	"./order/recharge-order-manage/components/machine-translation/index": [
		"F4Ma",
		0,
		22
	],
	"./order/recharge-order-manage/components/machine-translation/index.less": [
		"ClJj",
		86
	],
	"./order/recharge-order-manage/components/machine-translation/index.vue": [
		"F4Ma",
		0,
		22
	],
	"./order/recharge-order-manage/components/screen-recognition": [
		"kmC2",
		0,
		44
	],
	"./order/recharge-order-manage/components/screen-recognition/": [
		"kmC2",
		0,
		44
	],
	"./order/recharge-order-manage/components/screen-recognition/index": [
		"kmC2",
		0,
		44
	],
	"./order/recharge-order-manage/components/screen-recognition/index.less": [
		"Edif",
		85
	],
	"./order/recharge-order-manage/components/screen-recognition/index.vue": [
		"kmC2",
		0,
		44
	],
	"./order/recharge-order-manage/index": [
		"h2Qi",
		20
	],
	"./order/recharge-order-manage/index.less": [
		"3ts+",
		84
	],
	"./order/recharge-order-manage/index.vue": [
		"h2Qi",
		20
	],
	"./recruit": [
		"Ftv7",
		56
	],
	"./recruit/": [
		"Ftv7",
		56
	],
	"./recruit/announcement": [
		"oNG+",
		0,
		46
	],
	"./recruit/announcement/": [
		"oNG+",
		0,
		46
	],
	"./recruit/announcement/index": [
		"oNG+",
		0,
		46
	],
	"./recruit/announcement/index.less": [
		"B5HE",
		83
	],
	"./recruit/announcement/index.vue": [
		"oNG+",
		0,
		46
	],
	"./recruit/index": [
		"Ftv7",
		56
	],
	"./recruit/index.vue": [
		"Ftv7",
		56
	],
	"./recruit/job": [
		"BXPY",
		43
	],
	"./recruit/job/": [
		"BXPY",
		43
	],
	"./recruit/job/index": [
		"BXPY",
		43
	],
	"./recruit/job/index.less": [
		"ZVrr",
		82
	],
	"./recruit/job/index.vue": [
		"BXPY",
		43
	],
	"./task": [
		"4KEO",
		55
	],
	"./task/": [
		"4KEO",
		55
	],
	"./task/index": [
		"4KEO",
		55
	],
	"./task/index.vue": [
		"4KEO",
		55
	],
	"./task/list": [
		"seoI",
		0,
		28
	],
	"./task/list/": [
		"seoI",
		0,
		28
	],
	"./task/list/index": [
		"seoI",
		0,
		28
	],
	"./task/list/index.less": [
		"yUPk",
		81
	],
	"./task/list/index.vue": [
		"seoI",
		0,
		28
	],
	"./user": [
		"md3T",
		54
	],
	"./user/": [
		"md3T",
		54
	],
	"./user/account": [
		"ojg9",
		18
	],
	"./user/account-number": [
		"KXF7",
		0,
		49
	],
	"./user/account-number/": [
		"KXF7",
		0,
		49
	],
	"./user/account-number/index": [
		"KXF7",
		0,
		49
	],
	"./user/account-number/index.less": [
		"qO4d",
		80
	],
	"./user/account-number/index.vue": [
		"KXF7",
		0,
		49
	],
	"./user/account/": [
		"ojg9",
		18
	],
	"./user/account/components/intelligent-dubbing": [
		"mNJz",
		0,
		17
	],
	"./user/account/components/intelligent-dubbing/": [
		"mNJz",
		0,
		17
	],
	"./user/account/components/intelligent-dubbing/index": [
		"mNJz",
		0,
		17
	],
	"./user/account/components/intelligent-dubbing/index.less": [
		"JAQj",
		79
	],
	"./user/account/components/intelligent-dubbing/index.vue": [
		"mNJz",
		0,
		17
	],
	"./user/account/components/listening-and-translation": [
		"0ZSX",
		0,
		30
	],
	"./user/account/components/listening-and-translation/": [
		"0ZSX",
		0,
		30
	],
	"./user/account/components/listening-and-translation/index": [
		"0ZSX",
		0,
		30
	],
	"./user/account/components/listening-and-translation/index.less": [
		"J6+A",
		78
	],
	"./user/account/components/listening-and-translation/index.vue": [
		"0ZSX",
		0,
		30
	],
	"./user/account/components/machine-translation": [
		"cCdp",
		0,
		9
	],
	"./user/account/components/machine-translation/": [
		"cCdp",
		0,
		9
	],
	"./user/account/components/machine-translation/index": [
		"cCdp",
		0,
		9
	],
	"./user/account/components/machine-translation/index.less": [
		"xpaL",
		77
	],
	"./user/account/components/machine-translation/index.vue": [
		"cCdp",
		0,
		9
	],
	"./user/account/components/screen-recognition": [
		"wqTt",
		0,
		42
	],
	"./user/account/components/screen-recognition/": [
		"wqTt",
		0,
		42
	],
	"./user/account/components/screen-recognition/index": [
		"wqTt",
		0,
		42
	],
	"./user/account/components/screen-recognition/index.less": [
		"gvEv",
		76
	],
	"./user/account/components/screen-recognition/index.vue": [
		"wqTt",
		0,
		42
	],
	"./user/account/index": [
		"ojg9",
		18
	],
	"./user/account/index.less": [
		"hDcG",
		75
	],
	"./user/account/index.vue": [
		"ojg9",
		18
	],
	"./user/certificate": [
		"s3gm",
		27
	],
	"./user/certificate/": [
		"s3gm",
		27
	],
	"./user/certificate/components/built-in": [
		"0VRh",
		0,
		8
	],
	"./user/certificate/components/built-in/": [
		"0VRh",
		0,
		8
	],
	"./user/certificate/components/built-in/index": [
		"0VRh",
		0,
		8
	],
	"./user/certificate/components/built-in/index.less": [
		"htXj",
		74
	],
	"./user/certificate/components/built-in/index.vue": [
		"0VRh",
		0,
		8
	],
	"./user/certificate/components/custom": [
		"JC+T",
		0,
		7
	],
	"./user/certificate/components/custom/": [
		"JC+T",
		0,
		7
	],
	"./user/certificate/components/custom/index": [
		"JC+T",
		0,
		7
	],
	"./user/certificate/components/custom/index.less": [
		"cc6x",
		73
	],
	"./user/certificate/components/custom/index.vue": [
		"JC+T",
		0,
		7
	],
	"./user/certificate/index": [
		"s3gm",
		27
	],
	"./user/certificate/index.less": [
		"I9UL",
		72
	],
	"./user/certificate/index.vue": [
		"s3gm",
		27
	],
	"./user/index": [
		"md3T",
		54
	],
	"./user/index.vue": [
		"md3T",
		54
	],
	"./user/interpreter": [
		"5Kmu",
		0,
		3
	],
	"./user/interpreter/": [
		"5Kmu",
		0,
		3
	],
	"./user/interpreter/img/arrow.png": [
		"DPzw",
		65
	],
	"./user/interpreter/index": [
		"5Kmu",
		0,
		3
	],
	"./user/interpreter/index.less": [
		"DocM",
		71
	],
	"./user/interpreter/index.vue": [
		"5Kmu",
		0,
		3
	],
	"./youtube": [
		"UzFQ",
		53
	],
	"./youtube/": [
		"UzFQ",
		53
	],
	"./youtube/index": [
		"UzFQ",
		53
	],
	"./youtube/index.vue": [
		"UzFQ",
		53
	],
	"./youtube/monitoring": [
		"M7Xy",
		52
	],
	"./youtube/monitoring/": [
		"M7Xy",
		52
	],
	"./youtube/monitoring/channel": [
		"c0cC",
		48
	],
	"./youtube/monitoring/channel/": [
		"c0cC",
		48
	],
	"./youtube/monitoring/channel/index": [
		"c0cC",
		48
	],
	"./youtube/monitoring/channel/index.less": [
		"pZOL",
		70
	],
	"./youtube/monitoring/channel/index.vue": [
		"c0cC",
		48
	],
	"./youtube/monitoring/copyright": [
		"XQhI",
		36
	],
	"./youtube/monitoring/copyright/": [
		"XQhI",
		36
	],
	"./youtube/monitoring/copyright/index": [
		"XQhI",
		36
	],
	"./youtube/monitoring/copyright/index.less": [
		"U2uL",
		69
	],
	"./youtube/monitoring/copyright/index.vue": [
		"XQhI",
		36
	],
	"./youtube/monitoring/importrecord": [
		"XaXL",
		29
	],
	"./youtube/monitoring/importrecord/": [
		"XaXL",
		29
	],
	"./youtube/monitoring/importrecord/index": [
		"XaXL",
		29
	],
	"./youtube/monitoring/importrecord/index.less": [
		"hMIu",
		68
	],
	"./youtube/monitoring/importrecord/index.vue": [
		"XaXL",
		29
	],
	"./youtube/monitoring/index": [
		"M7Xy",
		52
	],
	"./youtube/monitoring/index.vue": [
		"M7Xy",
		52
	],
	"./youtube/monitoring/revenuelist": [
		"x/0P",
		35
	],
	"./youtube/monitoring/revenuelist/": [
		"x/0P",
		35
	],
	"./youtube/monitoring/revenuelist/index": [
		"x/0P",
		35
	],
	"./youtube/monitoring/revenuelist/index.less": [
		"00TT",
		67
	],
	"./youtube/monitoring/revenuelist/index.vue": [
		"x/0P",
		35
	],
	"./youtube/monitoring/videos": [
		"fRJn",
		0,
		12
	],
	"./youtube/monitoring/videos/": [
		"fRJn",
		0,
		12
	],
	"./youtube/monitoring/videos/index": [
		"fRJn",
		0,
		12
	],
	"./youtube/monitoring/videos/index.less": [
		"3VcO",
		66
	],
	"./youtube/monitoring/videos/index.vue": [
		"fRJn",
		0,
		12
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "MWF8";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*$
// module id = MWF8
// module chunks = 118